import environments from './environments';

let mode = '';
switch(__MODE__) {
    case environments.PRODUCTION:
        mode = environments.PRODUCTION; break;
    case environments.DEVELOPMENT:
        mode = environments.DEVELOPMENT; break;
    case environments.CUSTOM:
        mode = environments.CUSTOM; break;
}

export default mode;